import React from 'react';
import Link from 'next/link';

import styles from './styles.module.scss'

interface IActionSection {
  gradient?: boolean;
  header: string;
  text: string;
  buttonText: string;
  href: string;
  className?: string;
}

export default function ActionSection({ header, text, buttonText, href, gradient=true, className } : IActionSection)  {
  return (
    <div className={`${styles.actionSection} padding section ${gradient && styles.gradient} ${className}`}>
      <div className={styles.holder}>
        <div className={styles.textHolder}>
          <h1 className='middle-header'>{ header }</h1>
          <p className='text'>{ text }</p>
        </div>

        <div className={styles.buttonHolder}>
          <Link href={href} passHref>
            <button className={`${styles.actionButton} blue-button action-button`}>{ buttonText }</button>
          </Link>
        </div>
      </div>
    </div>
  )
};
